import { Card, Col, Row } from 'antd'
import React from 'react'
import members from './members.json'
import { motion } from "framer-motion";

export default function HEC() {
  return (
    <div style={{minHeight: '80vh'}}>
      <h2
        style={{
          fontSize: "1.8rem",
          marginBottom: "20px",
          fontWeight: 600,
        }}
      >Hall XI Wardens</h2>

      <Row justify="center" align="start" wrap={true}>
        {/* <Col>Item 2</Col>
        <Col>Item 3</Col> */}
        {members.map((person, index) => (

          person.type == "warden" &&
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            style={{margin:'6px 0'}}
          >
            <Col key={index} style={{ alignItems: 'start', width: '250px', margin:"4px 20px" }}>
              <Card hoverable style={{ height: '100%', width: '100%' }}>
                <img src={"images/" + person.img + ".webp"} style={{ maxWidth: '150px', borderRadius: '50%' }} />
                <p>{person.desig}</p>
                <p>{person.desig2 && person.desig2}</p>
                <p>{person.name}</p>
              </Card>
            </Col>
          </motion.div>
        ))}
      </Row>

      <h2>HEC (2025-2026)</h2>

      <Row justify="center" align="start" wrap={true}>
        {/* <Col>Item 2</Col>
        <Col>Item 3</Col> */}
        {members.map((person, index) => (
          person.type == "hec" && <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            style={{ margin: "6px 0" }}
          >
            <Col key={index} style={{ alignItems: 'start', width: '250px' , margin:"0 20px", height: '100%'}}>
              <Card hoverable style={{ height: '100%', width: '100%' }}>
                <img src={"images/" + person.img + ".webp"} style={{ maxWidth: '150px', borderRadius: '50%' }} />
                <p>{person.desig}</p>
                <p>{person.desig2 && person.desig2}</p>
                <p>{person.name}</p>
              </Card>
            </Col>
          </motion.div>
        ))}
      </Row>

    </div>
  )
}
